import { useEffect } from 'react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

import { expandWidget, selectSettings, selectComposed } from '@/features';
import { useAppDispatch, useAppSelector } from '@/store';
import { SS_FORCE_EXPAND_IN_VIEWER } from '@/constants';

export const useForcedExpandInViewer = () => {
  const dispatch = useAppDispatch();
  const { isEditor, isMobile } = useEnvironment();
  const neverLoadedSettings = useAppSelector(selectSettings.neverLoaded);
  const shouldAutoOpenWidget = useAppSelector(
    selectComposed.shouldAutoOpenWidget,
  );

  useEffect(() => {
    if (isEditor || neverLoadedSettings || isMobile) {
      return;
    }

    if (
      shouldAutoOpenWidget &&
      !JSON.parse(sessionStorage.getItem(SS_FORCE_EXPAND_IN_VIEWER) ?? 'false')
    ) {
      dispatch(expandWidget());
      sessionStorage.setItem(SS_FORCE_EXPAND_IN_VIEWER, 'true');
    }
  }, [isEditor, neverLoadedSettings, shouldAutoOpenWidget, isMobile, dispatch]);
};
